export const isProdBuild = import.meta.env.VITE_ACTIVE_ENV === 'production';

// Build-time switch; anything but 'true' keeps the mandate flows off.
export const isSepaMandatesEnabled = () =>
  import.meta.env.VITE_SEPA_MANDATES_ENABLED === 'true';

export const APP_URL = window?.location?.origin;
